const captureException = (exception: Error) => {
	console.log(exception);
};

export default captureException;
